import OneTrustButton from 'src/components-v3/Footer/OneTrustButton';

const PrivacyChoices = () => {
  return (
    <OneTrustButton
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        [theme.breakpoints.between(550, 1400 + 1)]: {
          flexDirection: 'row',
          alignItems: 'center',
          gap: theme.spacing(4.5),
        },
        [theme.breakpoints.up(1400 + 1)]: {
          alignItems: 'flex-end',
          gap: theme.spacing(1.5),
        },
        transition: 'color 0.1s ease-in-out',
        font: 'inherit',
        color: 'inherit',
        '&:hover': {
          color: '#0072cf',
        },
      })}
    />
  );
};

export default PrivacyChoices;
